import { actionObject } from "@/utils";
import {
    COLLABORATORS_STORIES_GET,
    CLEAR_COLLABORATORS,
    COLLABORATOR_GET,
    GUEST_INVITED,
    INVITE_ACCEPTED,
    INVITE_COLLABORATOR,
    REMOVE_COLLABORATOR,
    REMOVE_COLLABORATOR_NOREGISTER,
    UPDATE_COLLABORATOR,
    RESET_COLLABORATOR_ACTION_SUCCESS,
    SET_PENDING_INVITE,
    CLEAR_PENDING_INVITE,
    EXECUTE_PENDING_INVITE,
} from "./action-types";

export const inviteCollaborator = (payload: any) => actionObject(INVITE_COLLABORATOR, payload);
export const setGuest = (payload: any) => actionObject(GUEST_INVITED, payload);
export const inviteAccepted = (payload: any) => actionObject(INVITE_ACCEPTED, payload);
export const removeCollaborator = (payload: any) => actionObject(REMOVE_COLLABORATOR, payload);
export const getCollaboratorStory = (payload: any) => actionObject(COLLABORATOR_GET, payload);
export const getCollaboratorsStories = (payload: any) => actionObject(COLLABORATORS_STORIES_GET, payload);
export const removeCollaboratorNoRegister = (payload: any) => actionObject(REMOVE_COLLABORATOR_NOREGISTER, payload);
export const clearCollaborators = () => actionObject(CLEAR_COLLABORATORS);
export const updateCollaborator = (payload: any) => actionObject(UPDATE_COLLABORATOR, payload);
export const resetCollaboratorActionSuccess = () => actionObject(RESET_COLLABORATOR_ACTION_SUCCESS);

export const setPendingInvite = (data: any) => ({
  type: SET_PENDING_INVITE,
  payload: data,
});

export const clearPendingInvite = () => ({
  type: CLEAR_PENDING_INVITE,
});

export const executePendingInvite = () => ({
  type: EXECUTE_PENDING_INVITE,
});


